export enum GameDisallowedReason {
  // School / district service.
  District = 'District',
  Parent = 'Parent',
  ParentOptIn = 'ParentOptIn',
  Grade = 'Grade',
  Homework = 'Homework',

  // Game service.
  PlayTime = 'PlayTime'
}
